// In production, we register a service worker to serve assets from local cache.

import sendLogError from "./sendLogError";

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

export default function register() {
  // console.log("Envioriment:", process.env.NODE_ENV);
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    console.log("PublicUrl:", publicUrl);
    if (publicUrl.origin !== window.location.origin) {
      console.log("PUBLIC_URL is on a different origin");
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
      return;
    }
    // console.log("Invocando load");
    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      console.log("Event Load Requesting swUrl:", swUrl);
      if (isLocalhost) {
        // This is running on localhost. Lets check if a service worker still exists or not.
        checkValidServiceWorker(swUrl);
      } else {
        // Is not local host. Just register service worker
        registerValidSW(swUrl);
      }
    });
    // console.log("Fim Registro registerServiceWorker");
  }
}

function registerValidSW(swUrl) {
  console.log("registerValidSW");
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        console.log("Installing");
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          console.log("State", installingWorker.state);
          if (installingWorker.state === "installed") {
            console.log("installed");
            if (navigator.serviceWorker.controller) {
              // At this point, the old content will have been purged and
              // the fresh content will have been added to the cache.
              // It's the perfect time to display a "New content is
              // available; please refresh." message in your web app.
              console.log("New content is available; please refresh.");
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log("Content is cached for offline use.");
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

async function checkValidServiceWorker(swUrl) {
  console.log("checkValidServiceWorker");

  try {
    const response = await fetch(swUrl);

    const contentType = response.headers.get("content-type");

    const isJavascript = contentType && contentType.includes("javascript");

    // SW não existe ou não é válido
    if (!response.ok || !isJavascript) {
      console.warn("No valid service worker found. Reloading...");

      const registration = await navigator.serviceWorker.ready;

      await registration.unregister();

      window.location.reload();
      return;
    }

    console.log("Service worker found. Proceed as normal.");

    registerValidSW(swUrl);
  } catch (error) {
    console.error("Service worker check failed:", error);

    // offline mode — comportamento esperado
    console.warn("No internet connection. App running in offline mode.");

    // opcional
    sendLogError?.(error.message, "checkValidServiceWorker");
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
